import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { Order } from '../model/order.model';

@Component({
    selector: 'basket-order',
    templateUrl: './basket-order.component.html',
    styleUrls: ['./basket-order.component.scss'],
    standalone: false,
})
export class BasketOrderComponent {
    order: InputSignal<Order[]> = input.required();

    // Every resulting order was submitted to an approval process ("Freigabeprozess").
    protected readonly allRequireApproval: Signal<boolean> = computed(() => {
        const orders = this.order();
        return orders.length > 0 && orders.every((order) => order.requiresApproval);
    });

    // No resulting order needs approval -> everything was placed directly.
    protected readonly noneRequireApproval: Signal<boolean> = computed(() => {
        const orders = this.order();
        return orders.length > 0 && orders.every((order) => !order.requiresApproval);
    });
}
